import { render, staticRenderFns } from "./ModalDeleteKonten.vue?vue&type=template&id=cc94468c&"
import script from "./ModalDeleteKonten.vue?vue&type=script&lang=js&"
export * from "./ModalDeleteKonten.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports